import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import './style.css';
import { Link } from "react-router-dom";

import FotoProfile from '../../../assets/img/user-profile.png';

import Api from '../../../helpers/api';
import { clearLocalStorageExcept } from 'thesis-and-dissertations/helpers/helper';

const api = new Api();

const Header = (props) => {
    let navigate = useNavigate()
    const [collapseShow, setCollapseShow] = useState(false)
    const [activeButton, setaAtiveButton] = useState('register')
    const [user, setUser] = useState({})

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem('user')))
    }, [])

    const toggleCollapse = () => {
        setCollapseShow(!collapseShow)
    }

    const clickButton = () => {
        setaAtiveButton(activeButton == 'login' ? 'register' : 'login')
    }

    const logout = () => {
        clearLocalStorageExcept([])
        navigate('/thesis/login')
    }

    return (
        <>
            <div className="card px-4" id="web-view">
                <div className="row px-15 py-5">
                    <div className="col-md-6">
                        <Link to={'/'} className='color-orange fontweight-600'>
                            <img width={200} height={35} src={require('../../../assets/img/lpdp-talenta.png')} alt="Logo LPDP Talenta" />
                        </Link>
                    </div>

                    {/* COMMENTED: Login/Register buttons - thesis login feature disabled
                    {props?.button ?
                        user?.fullname ?
                            <div className="col-md-6" style={{ textAlign: 'right' }}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <img
                                        src={user?.path_url_foto ? user?.path_url_foto : FotoProfile}
                                        width={35}
                                        height={35}
                                        className="rounded-circle"
                                        alt="Profile Image"
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = FotoProfile;
                                        }} />

                                    <div className="dropdown">
                                        <button
                                            className="btn btn-sm btn-primary-outline dropdown-toggle"
                                            id="dropdownProfile"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false">
                                            {user?.fullname}
                                        </button>

                                        <ul className="dropdown-menu" aria-labelledby="dropdownProfile">
                                            <li>
                                                <Link
                                                    className={`btn btn-sm rounded-pill`}
                                                    onClick={() => clickButton('profile')}
                                                    to={'/profile-user'}>Profile</Link>
                                            </li>
                                            <li>
                                                <button
                                                    type='button'
                                                    className={`btn btn-sm rounded-pill`}
                                                    onClick={() => logout()}>Logout</button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div> :
                            <div className="col-md-6" style={{ textAlign: 'right' }}>
                                <Link
                                    className={`btn btn-sm ${activeButton == 'login' ? 'btn-primary' : ''} rounded-pill`}
                                    style={{ color: activeButton == 'login' ? '#FFFFFF' : '#FF6C06' }}
                                    onClick={() => clickButton('login')}
                                    to={'/thesis/login'}>Login</Link>

                                <Link
                                    className={`btn btn-sm ${activeButton == 'register' ? 'btn-primary' : ''} rounded-pill`}
                                    style={{ color: activeButton == 'register' ? '#FFFFFF' : '#FF6C06' }}
                                    onClick={() => clickButton('register')}
                                    to={'/thesis/register'}>Pendaftaran</Link>
                            </div>
                        : null} */}
                </div>
            </div>

            <nav className="navbar navbar-expand-lg navbar-light bg-light bg-white" id="mobile-view" style={{ marginTop: '-5px' }}>
                <div className="container-fluid bg-white px-15" >
                    <Link to={'/'} className='navbar-brand'>
                        <img width={200} height={35} src={require('../../../assets/img/lpdp-talenta.png')} alt="Logo LPDP Talenta" />
                    </Link>
                    {/* COMMENTED: Mobile login/register buttons - thesis login feature disabled */}
                    {/* {props.button ?
                        <>
                            <button
                                onClick={() => toggleCollapse()}
                                className={`navbar-toggler ${collapseShow ? 'collapsed' : null}`}
                                type="button"
                                data-toggle="collapse"
                                data-target="#navbarNavAltMarkup"
                                aria-controls="navbarNavAltMarkup"
                                aria-expanded="false"
                                aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <div className={`collapse navbar-collapse  ${collapseShow ? 'show' : null} `} id="navbarNavAltMarkup">
                                <div className="navbar-nav ml-auto p-5">
                                    {user?.fullname ?
                                        <>
                                            <Link
                                                className={`btn btn-sm btn-primary rounded-pill`}
                                                style={{ color: '#FFFFFF' }}
                                                onClick={() => clickButton('profile')}
                                                to={'/profile-user'}
                                            >Profil</Link>

                                            <button
                                                type='button'
                                                className={`btn btn-sm ${activeButton == 'logout' ? 'btn-primary' : ''} rounded-pill`}
                                                onClick={() => logout()}>Logout</button>
                                        </>
                                        :
                                        <>
                                            <Link
                                                className={`btn btn-sm ${activeButton == 'login' ? 'btn-primary' : ''} rounded-pill`}
                                                style={{ color: activeButton == 'login' ? '#FFFFFF' : '#FF6C06' }}
                                                onClick={() => clickButton('login')}
                                                to={'/thesis/login'}>Login</Link>

                                            <Link
                                                className={`btn btn-sm ${activeButton == 'register' ? 'btn-primary' : ''} rounded-pill`}
                                                style={{ color: activeButton == 'register' ? '#FFFFFF' : '#FF6C06' }}
                                                onClick={() => clickButton('register')}
                                                to={'/thesis/register'}>Pendaftaran</Link>
                                        </>
                                    }
                                </div>
                            </div>
                        </>
                        : null} */}
                </div>
            </nav>
        </>
    )
}

export default Header;